import Loadable from "react-loadable"
import { Loading } from "@/components/Loading"

export const LoginSSO = Loadable({
  loader: () => import("./LoginSSO"),
  loading: Loading
})
